import { useEffect, useState } from 'react';

export type PrintMode = 'screen' | 'eco';
export type PrintOptions = { mode: PrintMode; background: boolean };

const STORAGE_KEY = 'rd-print';
const DEFAULTS: PrintOptions = { mode: 'screen', background: false };

function load(): PrintOptions {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? 'null') as Partial<PrintOptions> | null;
    return { mode: stored?.mode === 'eco' ? 'eco' : 'screen', background: stored?.background === true };
  } catch {
    return DEFAULTS;
  }
}

/**
 * Print style ("Zoals op scherm" / "Inktzuinig") and whether the page background is printed. Remembered in
 * localStorage and mirrored as data attributes on <html>, which the @media print rules in index.css read.
 */
export function usePrintOptions() {
  const [options, setOptions] = useState<PrintOptions>(load);
  useEffect(() => {
    const root = document.documentElement;
    root.dataset.print = options.mode;
    if (options.background) root.dataset.printBg = '1';
    else delete root.dataset.printBg;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(options));
    } catch {
      // Storage unavailable: the choice just is not remembered.
    }
  }, [options]);
  return [options, setOptions] as const;
}
